module.exports = __webpack_public_path__ + "static/sign-up-form-1-7-fa2df36d81eeafcefc8debecda78324f.png";